<!-- Para recoger los valores default que vienen de la PAI REST en los input VTextFieldWithValidation y VSelectWithValidation incluir -> :default="c.value" 
  si no se incluye el formulario carga en blanco -->
<template slot="content">
  <v-container fluid>
    <v-form ref="form" v-on:submit.prevent>
      <v-row>
        <v-col :xs="12" :sm="4">
          <ValidationProvider rules="required">
            <v-autocomplete
              background-color="white"
              v-model.trim="country"
              :items="filteredCountries"
              :label="$t('bankDetails.countryLabel')"
              @change="loadFormByCountry($event)"
              filled
              class="pa-2"
              :no-data-text="
                isCountryValid ? '' : $t('bankDetails.errorCountry')
              "
            ></v-autocomplete>
          </ValidationProvider>
        </v-col>
      </v-row>

      <v-row v-if="config && country" no-gutters>
        <v-col
          v-for="(c, index) in config"
          cols="12"
          :sm="6"
          :md="!c.combined ? 4 : 6"
          :class="getClassesForCombined(c, index)"
          :key="c.field"
        >
          <div class="pa-2">
            <VTextFieldWithValidation
              v-if="c.type == 'text'"
              :rules="c.rules"
              :disabled="hasAssociation(c)"
              :counter="c.rules && c.rules.max ? c.rules.max : null"
              :label="c.label"
              :hide-details="!c.label"
              :placeholder="c.placeholder"
              v-model="dataForSend[c.field]"
            />
            <VSelectWithValidation
              v-if="c.type == 'select'"
              :rules="c.rules"
              :items="c.items"
              :item-text="'name'"
              :item-value="'value'"
              :placeholder="c.placeholder"
              v-model="dataForSend[c.field]"
              :label="c.label"
              :default="c.value"
              @change="onChangeSelect(c, $event)"
            />
          </div>
        </v-col>
      </v-row>
      <div
        class="file-row-wrapper"
        v-if="config && country && !$router.currentRoute.path.includes('/cat/')"
      >
        <ValidationProvider
          ref="fileInputProvider"
          rules="required"
          v-slot="{ errors }"
        >
          <div class="file-row-content">
            <input
              ref="hiddenFileInput"
              type="file"
              style="display: none"
              @change="(e) => handleFileInputChange(e)"
              :accept="'image/jpeg,image/jpg,image/png,application/pdf'"
            />
            <div class="file-link-container">
              <a
                href="#"
                @click.prevent="onFileInputClick"
                class="custom-file-link"
              >
                <v-icon left small>mdi-paperclip</v-icon>
                {{ $t("bankDetails.certificate") }}
              </a>
            </div>
            <div class="file-name-container" v-if="uploadedFile">
              <span class="file-name">{{ uploadedFile.name }}</span>
              <v-icon
                small
                class="ml-1 file-remove"
                @click="removeUploadedFile"
                color="red"
                >mdi-trash-can</v-icon
              >
            </div>
          </div>
          <div v-if="errors && errors.length" class="file-error-message">
            <span v-for="(err, idx) in errors" :key="idx" class="error--text">{{
              err
            }}</span>
          </div>
        </ValidationProvider>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import Api from "@/api/api";
import { ValidationProvider } from "vee-validate";
import VTextFieldWithValidation from "@/components/dynamic/VTextFieldWithValidation.vue";
import VSelectWithValidation from "@/components/dynamic/VSelectWithValidation.vue";
import { getRulesByField, getRulesByFieldBR } from "@/configs/validations";
import { mapStores, mapActions } from "pinia";
import { useCountriesStore } from "../../stores/countriesStore";
import { useUiStore } from "@/stores/uiStore";
import { useLanguageStore } from "@/stores/languageStore";

export default {
  name: "DynamicFormComponent",
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
    ValidationProvider,
  },
  data: () => ({
    caseId: null,
    config: null,
    country: null,
    dataForSend: {},
    language: null,
    locale: null,
    token: null,
    currencies: {
      AR: [
        { name: "ARS", value: "ARS" },
        { name: "USD", value: "USD" },
      ],
      BO: [
        { name: "BOB", value: "BOB" },
        { name: "USD", value: "USD" },
      ],
      GT: [
        { name: "GTQ", value: "GTQ" },
        { name: "USD", value: "USD" },
      ],
      HN: [
        { name: "HNL", value: "HNL" },
        { name: "USD", value: "USD" },
      ],
      PY: [
        { name: "PYG", value: "PYG" },
        { name: "USD", value: "USD" },
      ],
      PE: [
        { name: "PEN", value: "PEN" },
        { name: "USD", value: "USD" },
      ],
      DO: [
        { name: "DOP", value: "DOP" },
        { name: "USD", value: "USD" },
      ],
      UY: [
        { name: "UYU", value: "UYU" },
        { name: "USD", value: "USD" },
      ],
    },
    uploadedFile: null,
    fileDialogOpened: false,
  }),
  created() {
    this.loadCountries();
  },
  computed: {
    ...mapStores(useCountriesStore, useLanguageStore),
    filteredCountries() {
      return this.countriesStore.countryOptions(true);
    },
    isCountryValid() {
      return this.filteredCountries.includes(this.country);
    },
  },
  methods: {
    ...mapActions(useUiStore, ["changeSpinner"]),
    handleFileInputChange(e) {
      const file = e.target.files[0];
      this.uploadedFile = file;
      // Validar y mostrar errores en el ValidationProvider
      const errors = [];
      console.log("file", file);
      if (!file) {
        errors.push(this.$t("file.fileErrorRequired"));
      } else {
        if (!this.isValidFileFormat(file)) {
          errors.push(this.$t("file.fileFormatError"));
        }
        if (!this.isValidFileSize(file)) {
          errors.push(this.$t("file.fileSizeError"));
        }
      }
      if (errors.length > 0) {
        delete this.dataForSend["uploadedFile"];
        this.$refs.fileInputProvider.setErrors(errors);
      } else {
        this.dataForSend["uploadedFile"] = file;
        this.$refs.fileInputProvider.setErrors([]);
      }
      this.validateAndEmit();
      // Si el usuario abrió el diálogo y no seleccionó archivo, mostrar error obligatorio
      if (this.fileDialogOpened && !file) {
        this.$refs.fileInputProvider.setErrors([
          this.$t("file.fileErrorRequired"),
        ]);
        this.validateAndEmit();
      }
      this.fileDialogOpened = false;
    },

    onFileInputClick() {
      this.fileDialogOpened = true;
      this.$refs.hiddenFileInput.click();
      // Forzar validación si el usuario cancela el diálogo
      setTimeout(() => {
        // Si no hay archivo seleccionado y el input no tiene el foco
        const input = this.$refs.hiddenFileInput;
        if (
          this.fileDialogOpened &&
          !this.uploadedFile &&
          document.activeElement !== input
        ) {
          this.$refs.fileInputProvider.setErrors([
            this.$t("file.fileErrorRequired"),
          ]);
          this.validateAndEmit();
          this.fileDialogOpened = false;
        }
      }, 500);
    },

    // Eliminado onFileInputBlur, la lógica se maneja solo en handleFileInputChange
    removeUploadedFile() {
      console.log("removeUploadedFile", this.uploadedFile);
      this.uploadedFile = null;
      delete this.dataForSend["uploadedFile"];
      // Resetear el input file para permitir adjuntar el mismo archivo
      if (this.$refs.hiddenFileInput) {
        this.$refs.hiddenFileInput.value = null;
      }
      this.$refs.fileInputProvider.setErrors([
        this.$t("file.fileErrorRequired"),
      ]);
      this.validateAndEmit();
    },
    getClassesForCombined(actual, index) {
      let classes = {};
      const previous = this.config[index - 1];
      const isXs = this.$vuetify.breakpoint.xs;
      if (actual.combined) {
        classes["combined grey lighten-2"] = actual.combined;
        if (!previous?.pyLabel) {
          classes[isXs ? "rounded-t" : "rounded-l"] = true;
        }
        if (previous?.pyLabel === actual?.pyLabel) {
          classes[isXs ? "rounded-b" : "rounded-r"] = true;
        }
      }
      return classes;
    },

    setDefaultCountry() {
      if (this?.$attrs?.values?.["CountryCode"]) {
        this.country = this.filteredCountries.find(
          (opt) => opt?.value?.isocode === this?.$attrs?.values["CountryCode"]
        )?.value;
        this.loadFormByCountry({
          isocode: this?.$attrs?.values["CountryCode"],
        });
      }
    },
    async resetForm() {
      this.dataForSend = { CountryCode: this.country.isocode };
    },
    async validateAndEmit() {
      // Valida el formulario de Vuetify
      const isFormValid = await this.$refs.form.validate();
      // Emite el estado al padre/hijo
      this.$emit("form-validity", isFormValid);
    },
    onFileChange(file) {
      // Cada vez que cambia el archivo, valida y emite
      this.uploadedFile = file;
      if (file && this.isValidFileFormat(file) && this.isValidFileSize(file)) {
        this.dataForSend["uploadedFile"] = file;
      } else {
        delete this.dataForSend["uploadedFile"];
      }
      this.validateAndEmit();
    },
    onChangeSelect({ field, associated }, value) {
      if (!associated || !field) return;
      let associatedField = this.config.findIndex((x) => x.field == associated);
      if (!Number.isInteger(associatedField)) return;
      const customValidations = {
        AccountHolderDocType: () => {
          this.config[associatedField].rules = {
            ...this.config[associatedField].rules,
            validateDoc: [value],
          };
        },
      };
      if (customValidations[field]) customValidations[field]();
    },
    hasAssociation(reference) {
      const fieldAssociated = this.config?.find(
        (f) => f.associated === reference.field
      );
      if (!fieldAssociated) return;
      return !this.dataForSend[fieldAssociated?.field];
    },
    async loadCountries() {
      try {
        this.changeSpinner(false);
        this.setDefaultCountry();
      } catch (error) {
        console.error(error);
        this.changeSpinner(false);
      }
    },
    mapFieldsForm(form) {
      const mappedFields = form?.map((d) => {
        let mapped = {
          field: d?.Field,
          countryCode: d?.CountryCode,
          maxLength: d?.MaxSize,
          minLength: d?.MinSize,
          label: d?.FieldName,
          type: d?.TypeDescription,
          combined: d?.CombinedField,
          required: d?.Required?.toLowerCase() === "true",
          placeholder: d?.ToolTipText,
          message: d?.pyMessage,
          pyLabel: d?.pyLabel,
          rules: {},
        };

        if (mapped.type === "select") {
          mapped.items = d?.pyItemGroup?.map((i) => ({
            name: i.Name,
            value: i.Value,
          }));
          // Create association for select and text input
          if (mapped.field === "AccountHolderDocType") {
            mapped.associated = "AccountHolderDocNumber";
          }
        }
        if (this?.$attrs?.values?.[mapped.field]) {
          mapped.value = this.$attrs.values[mapped.field];
        }
        /**
         * Comprobar si la ruta actual es "compensation-component" y el país es "BR" (Brasil).
         * Si se cumplen ambas condiciones, aplica las validaciones sobre dos campos Clave de banco y Número de cuenta.
         * En caso contrario, aplica las validaciones por defecto.
         */
        if (
          this.$router?.currentRoute?.name === "compensation-component" &&
          this.country.isocode === "BR"
        ) {
          mapped.rules = {
            ...getRulesByFieldBR(mapped),
          };
          return mapped;
        }
        mapped.rules = { ...getRulesByField(mapped) };
        return mapped;
      });

      // **Agregar el campo de divisas solo si el país tiene divisas definidas y la ruta no contiene "cat"**
      if (
        this.currencies[this.country?.isocode] &&
        !this.$router.currentRoute.path.includes("/cat/")
      ) {
        const currencyField = {
          field: "AccountCurrency",
          label: this.$t("bankDetails.accountCurrency"),
          type: "select",
          items: this.currencies[this.country.isocode],
          rules: { required: true },
        };

        mappedFields.push(currencyField);
      }

      return mappedFields;
    },
    async loadFormByCountry(country) {
      if (!country?.isocode && !this.country?.isocode) return;
      try {
        this.changeSpinner(true);
        this.config = null;
        this.dataForSend = { CountryCode: this.country.isocode };

        const r = await Api.dynamicForm(
          country.isocode || this.country.isocode,
          this.languageStore.language.toUpperCase()
        );
        const data = r.data;
        const json = data?.JsonResponse;
        this.config = this.mapFieldsForm(json);

        this.changeSpinner(false);

        // Emitir el evento
        this.$nextTick(() => {
          if (this.uploadedFile) {
            this.dataForSend["uploadedFile"] = this.uploadedFile; // Asegurar de incluir el archivo
          }
          this.$emit("form-ready", this.dataForSend);
        });
      } catch (error) {
        console.error(error);
        this.changeSpinner(false);
      }
    },
    validateFileInput(value) {
      const errors = [];
      if (!value) {
        errors.push(this.$t("file.fileErrorRequired"));
      } else {
        if (!this.isValidFileFormat(value)) {
          errors.push(this.$t("file.fileFormatError"));
        }
        if (!this.isValidFileSize(value)) {
          errors.push(this.$t("file.fileSizeError"));
        }
      }

      // Si hay errores, limpia el archivo y marca el campo como inválido
      if (errors.length > 0) {
        this.uploadedFile = null;
        delete this.dataForSend["uploadedFile"];
        this.$refs.fileInputProvider.setErrors(errors);
      } else {
        this.$refs.fileInputProvider.setErrors([]);
      }
    },
    isValidFileFormat(file) {
      if (!file) return false; // Si no hay archivo, no es válido
      const allowedFormats = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
      ];
      return allowedFormats.includes(file.type);
    },
    isValidFileSize(file) {
      if (!file) return false; // Si no hay archivo, no es válido
      const maxSizeInBytes = 4 * 1024 * 1024; // 4 MB en bytes
      return file.size <= maxSizeInBytes;
    },
    handleFileUpload(file) {
      // Si no hay archivo seleccionado, limpia el modelo
      if (!file) {
        this.uploadedFile = null;
        delete this.dataForSend["uploadedFile"];
        return;
      }

      // Si el archivo no es válido, no lo subas
      if (!this.isValidFileFormat(file) || !this.isValidFileSize(file)) {
        this.uploadedFile = null;
        delete this.dataForSend["uploadedFile"];
        return;
      }

      this.uploadedFile = file;
      this.dataForSend["uploadedFile"] = file;
    },
  },
  watch: {
    country(data) {
      this.dataForSend["CountryCode"] = data?.isocode;
      // Resetear archivo seleccionado al cambiar país
      this.uploadedFile = null;
      delete this.dataForSend["uploadedFile"];
      if (this.$refs.hiddenFileInput) {
        this.$refs.hiddenFileInput.value = null;
      }
      if (this.$refs.fileInputProvider) {
        this.$refs.fileInputProvider.setErrors([]);
      }
      // Emitir evento para que el padre pueda resetear isFormValidFile
      this.$emit("reset-file-validity");
    },
  },
};
</script>

<style scoped>
.w-50 {
  width: 50%;
}
.w-100 {
  width: 100%;
}
.form-container {
  background-color: #f6f6f6;
}
.custom-file-input .v-input__control {
  text-align: center; /* Centrar el texto del archivo adjuntado */
  display: flex; /* Asegura que el contenido esté alineado */
  align-items: center; /* Alinea verticalmente el texto y el ícono */
  padding: 0 !important; /* Elimina cualquier padding del contenedor */
}

.custom-file-input .v-file-input__text {
  flex: 1; /* Permite que el texto ocupe el espacio disponible */
  text-align: center; /* Centra el texto horizontalmente */
  padding: 0 !important; /* Elimina cualquier padding del texto */
  margin: 0 !important; /* Asegura que no haya márgenes adicionales */
}

.custom-file-input .v-input__icon--clear {
  color: red; /* Cambia el color del ícono de papelera a rojo */
  margin-left: 8px; /* Añade un pequeño margen entre el texto y el ícono */
  align-self: center; /* Asegura que el ícono esté alineado verticalmente con el texto */
}

.v-file-input.v-text-field--filled:not(.v-text-field--single-line)
  .v-file-input__text {
  padding: 0 !important; /* Elimina cualquier padding superior */
  margin: 0 !important; /* Asegura que no haya márgenes adicionales */
}
.file-error-message {
  margin-top: 4px;
  color: #f44336;
  font-size: 0.85em;
  min-height: 18px;
}
.error--text {
  display: block;
  margin-left: 20px;
}
.file-row-wrapper {
  margin-top: 16px;
  width: 100%;
}
.file-row-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 0;
}
.file-link-container {
  display: flex;
  align-items: center;
  flex: none;
  margin-right: 4px;
}
.file-name-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
  flex: none;
  margin-left: 4px;
}
.file-name {
  font-size: 16px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: 200px; */
}
.file-remove {
  cursor: pointer;
  vertical-align: middle;
}
</style>
